import { Component, OnInit, inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-stats',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './stats.component.html',
  styleUrl: './stats.component.scss'
})
export class StatsComponent implements OnInit {
  private readonly platformId = inject(PLATFORM_ID);

  stats = [
    { label: 'Years of Experience', value: 14, suffix: '+' },
    { label: 'Sq. Ft. Developed', value: 2, suffix: 'L' },
    { label: 'Happy Clients', value: 250, suffix: '+' },
    { label: 'Commercial Units Sold', value: 310, suffix: '+' },
  ];

  displayedStats = [
    { label: 'Years of Experience', value: 0, suffix: '+' },
    { label: 'Sq. Ft. Developed', value: 0, suffix: 'L' },
    { label: 'Happy Clients', value: 0, suffix: '+' },
    { label: 'Commercial Units Sold', value: 0, suffix: '+' },
  ];

  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      this.displayedStats = this.stats.map((stat) => ({ ...stat }));
      return;
    }

    this.animateNumbers();
  }

  animateNumbers(): void {
    const duration = 2000;
    const startTime = Date.now();

    const animate = () => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / duration, 1);

      this.displayedStats.forEach((stat, index) => {
        stat.value = Math.floor(this.stats[index].value * progress);
      });

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    animate();
  }
}
